function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError503(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.76,432.31A24.74,24.74,0,1,1,274,399.52,24.73,24.73,0,0,1,261.76,432.31Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.16,107.29a39.79,39.79,0,0,0-9.85-9.82,145.36,145.36,0,0,0-15.56-8.06l-3.23-18a61.53,61.53,0,0,0,8.28-9.8c2.92-4.71,2-7.87.13-11.13s-4.46-1.15-4.85.34a33.33,33.33,0,0,0-.52,4.75s-1.74-12-2.75-14.73-4.86-.1-4.52.81c0,0-1.16-3.41-3.55-3.45s-3.07,4-3.07,4-3.07-1.42-4.79.36-.9,6.24-.9,6.24-2.74,1-3.16,4.89-.08,10.7,1,12.57a20.08,20.08,0,0,1,1.45,2.78c-1.36,16.24-1.31,15.17-1.71,21.65-.28,4.56,2.71,15.16,7,19.57s19.64,12.2,19.64,12.2S317.23,118.33,322.16,107.29Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.21,125.93s-4.47.47-5.88,1.68S264.19,138,262.45,143.44s4.87,21.72,12.09,28,16.24,12.93,23.9,11.56,16.46-13.17,17.37-16.38-29.06-40-29.06-40S284.62,124.48,282.21,125.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.39,104.12s-4.74-1.6-11.8,1.4-24.72,13.37-27.31,22.4c-1.71,5.93,17,33.62,28.69,38.18,3.14,1.22,6,2.55,12.43-2.69s19.91-19.79,23.44-26.2-2-11.19-3.85-14S325.35,102,320.39,104.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-138"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 341.93,
    cy: 103.81,
    r: 26.5,
    transform: "translate(-15.38 99.53) rotate(-16.2)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.71,134.5s-10.29-2.78-14.34,4.95.52,27,.52,27-7.52,12.22-9.43,13.55-7.29.75-12.59,3.45-3.55,5.47-2.14,6.4,5.73-1.85,7-1.75,1.13,2.39-3.87,7.58S305.57,201,307,203.4a3.69,3.69,0,0,0,4,1.79,2.57,2.57,0,0,0,1.4,3.07c2.06,1,2.94.23,2.94.23s-.2,2.61,1.71,3.41a8.13,8.13,0,0,0,4.59,0s1.81,2.12,3.64,1.77,6-5.45,9.3-9.79,16-19.77,21-29.23,2.63-19,1.61-24.83S351.55,135.78,347.71,134.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-7--inject-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.06,138.09s4.16,12,9.51,12.89,12.79-8.19,14.3-15-3.8-12.29-11.48-19.13-18.69-10.82-28-5.63-23.07,20-23.07,20-8.61-7.57-13.18-3.66,1.39,15.87,5.6,20.8S222.63,160.52,230,158.8s13.21-15.55,18-19.62S256,136.86,257.06,138.09Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-8--inject-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.13,180.59s12.17,3.58,16-.24,4.4-15.43-3.88-20.35c-6-3.54-12.21-4-22.24-1.76s-19.66,8.93-20.83,19.49,2.9,30.42,2.9,30.42-11.15,2.61-10.63,8.61,13.73,8.09,20.18,7.52,16.74-2.63,19.61-9.62-5-19.78-5.54-26S279.52,180.73,281.13,180.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.88,272.43s-.48,70.8,56.64,119.44,138.69,54.06,204.65,60.2S438.39,422,448.25,365.48s-40-74.42-64.93-139.64-21.63-86.38-78.1-127.52S157,79.26,106.81,146.07,58.88,272.43,58.88,272.43Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.88,272.43s-.48,70.8,56.64,119.44,138.69,54.06,204.65,60.2S438.39,422,448.25,365.48s-40-74.42-64.93-139.64-21.63-86.38-78.1-127.52S157,79.26,106.81,146.07,58.88,272.43,58.88,272.43Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--planet-3--inject-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.65,263.73a15.34,15.34,0,1,1,20.65-6.64A15.33,15.33,0,0,1,396.65,263.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.38,241.85l7.44,10.44a15.17,15.17,0,0,0-.34-6.08Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.78,236.94l17.68,24.94a15.17,15.17,0,0,0,3.61-4.38l-14.83-22.68A15.32,15.32,0,0,0,395.78,236.94Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.09,265.4l-7.68-11,4,10.42A15.58,15.58,0,0,0,403.09,265.4Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.33,264.32l-17.56-23.93c-.17.21-.33.44-.49.66L404,265.42A15.47,15.47,0,0,0,409.33,264.32Z",
    style: {
      fill: "#2762E6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--planet-2--inject-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.76,432.31A24.74,24.74,0,1,1,274,399.52,24.73,24.73,0,0,1,261.76,432.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-138)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.78,420.5,256.9,394l19.17,18.42c.05-.51.09-1,.11-1.54l-22.71-25.74a24.2,24.2,0,0,0-5.82.22l4.56,7.25-7.54-6.6h0l6,10.86-12.13-8.14c-.3.19-.6.38-.89.58l22.51,25-17.86-13.59,6.35,10-9.25-6.4,24.22,27.06a24.58,24.58,0,0,0,7.57-6.57l-4.93-8.23,6.12,6.52A23.74,23.74,0,0,0,273.78,420.5Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.77,433.45l-19.35-22.32,8.6,13.28-21.2-16.62a24.73,24.73,0,0,0,21.42,26.55l-7.64-6.79,11.86,7A25.24,25.24,0,0,0,258.77,433.45Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.69,386.87l10.85,12.6-2.2-4.81,3.51,2.7A24.63,24.63,0,0,0,260.69,386.87Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.46,406.36l-5.86-8.1a25.21,25.21,0,0,0-2.5,7.31Z",
    style: {
      fill: "#2762E6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288.23,393.36c-1.8-3.94-9.78-4.49-20.38-2.08a22.7,22.7,0,0,1,1.91,1.89c7.92-1.82,13.57-1.66,14.74.88,2.06,4.51-10.79,14.81-28.71,23s-34.1,11.19-36.17,6.68c-1.06-2.32,1.85-6.18,7.36-10.5a23.69,23.69,0,0,1-.23-2.65c-7.69,6-11.78,11.84-10.09,15.52,2.85,6.24,21.19,4,41-5.07S291.08,399.6,288.23,393.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--planet-1--inject-138"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 133.94,
    cy: 174.23,
    r: 24.43,
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.7,156.16a18.88,18.88,0,0,1,5.59-3.55,23.93,23.93,0,0,0-6.3-2.27,56.64,56.64,0,0,0-6.44,5c-8.74,7.94-6.36,7.15-19.06,11.91a19.87,19.87,0,0,0-3.37,1.62,24.06,24.06,0,0,0-.61,5.33,24.38,24.38,0,0,0,1.73,9c4.54-1.38,10.58-3.62,13.37-6.41C129.37,172.05,130.17,164.9,139.7,156.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.19,191a24.61,24.61,0,0,0,6.39,4.87c4.55-3.18,6.67-6.56,13.15-9.5,5.69-2.59,15.08-3.16,20.94-3.23a24.32,24.32,0,0,0,1.69-8.89c0-.42,0-.83-.06-1.25a70.36,70.36,0,0,0-20.19,4.63C128.87,181.3,124.39,187.85,116.19,191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.49,165.69c4.32,2.16,11,1,16.15-.44a24.52,24.52,0,0,0-4.11-6.83C145.65,159.71,134.51,162.7,140.49,165.69Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.93,368.3l.51-.84a7.3,7.3,0,0,0,5.07,1.94c3.08,0,4.44-1.34,4.44-3,0-4.61-9.6-1.85-9.6-7.51,0-2.18,1.67-4.09,5.45-4.09a8.2,8.2,0,0,1,4.63,1.39l-.42.9a7.57,7.57,0,0,0-4.21-1.3c-3,0-4.33,1.38-4.33,3.08,0,4.61,9.6,1.88,9.6,7.46,0,2.18-1.74,4.07-5.54,4.07A7.89,7.89,0,0,1,145.93,368.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.2,364.81h-9.86a4.9,4.9,0,0,0,8.52,3l.64.73a5.48,5.48,0,0,1-4.33,1.86,5.62,5.62,0,0,1-5.9-5.82,5.49,5.49,0,1,1,11,0C170.23,364.59,170.2,364.7,170.2,364.81Zm-9.84-.86h8.79a4.4,4.4,0,0,0-8.79,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.06,358.72v1.08l-.27,0c-2.55,0-4.06,1.69-4.06,4.52v6h-1.1V358.81h1.05v2.51A4.37,4.37,0,0,1,179.06,358.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.82,358.81l-5.19,11.47h-1.12l-5.16-11.47h1.17l4.56,10.26,4.62-10.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.86,355.14a.9.9,0,0,1,.9-.9.89.89,0,1,1-.9.9Zm.35,3.67h1.1v11.47h-1.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.69,364.54a5.59,5.59,0,0,1,5.8-5.82,5.06,5.06,0,0,1,4.35,2.11l-.81.6a4.19,4.19,0,0,0-3.54-1.72,4.84,4.84,0,0,0,0,9.67,4.19,4.19,0,0,0,3.54-1.72l.81.6a5.1,5.1,0,0,1-4.35,2.1A5.6,5.6,0,0,1,198.69,364.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.62,364.81h-9.86a4.9,4.9,0,0,0,8.52,3l.64.73a5.48,5.48,0,0,1-4.33,1.86,5.63,5.63,0,0,1-5.91-5.82,5.49,5.49,0,0,1,5.5-5.82,5.43,5.43,0,0,1,5.46,5.78C221.64,364.59,221.62,364.7,221.62,364.81Zm-9.84-.86h8.79a4.4,4.4,0,0,0-8.79,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.91,363.75V354.9H232v8.81c0,3.84,1.85,5.64,5.05,5.64s5-1.8,5-5.64V354.9h1.12v8.85c0,4.4-2.35,6.64-6.17,6.64S230.91,368.15,230.91,363.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.37,363.58v6.7h-1.1v-6.62c0-2.59-1.38-4-3.71-4a4.09,4.09,0,0,0-4.35,4.46v6.11h-1.1V358.81h1.06v2.48a4.72,4.72,0,0,1,4.54-2.57C256.5,358.72,258.37,360.37,258.37,363.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.17,363v7.27h-1.05v-2a4.4,4.4,0,0,1-4.13,2.13c-2.57,0-4.13-1.31-4.13-3.27,0-1.73,1.1-3.21,4.28-3.21h3.94V363c0-2.13-1.17-3.27-3.41-3.27a5.92,5.92,0,0,0-3.95,1.45l-.55-.79a7,7,0,0,1,4.59-1.63C269.59,358.72,271.17,360.17,271.17,363Zm-1.09,3.88v-2.15h-3.91c-2.38,0-3.21,1-3.21,2.31,0,1.49,1.16,2.41,3.18,2.41A3.93,3.93,0,0,0,270.08,366.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.68,358.81l-5.18,11.47h-1.12l-5.16-11.47h1.16L279,369.07l4.61-10.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,363v7.27H294v-2a4.39,4.39,0,0,1-4.13,2.13c-2.57,0-4.13-1.31-4.13-3.27,0-1.73,1.1-3.21,4.28-3.21h3.94V363c0-2.13-1.17-3.27-3.41-3.27a5.92,5.92,0,0,0-3.95,1.45l-.55-.79a7,7,0,0,1,4.59-1.63C293.42,358.72,295,360.17,295,363Zm-1.09,3.88v-2.15H290c-2.37,0-3.21,1-3.21,2.31,0,1.49,1.16,2.41,3.18,2.41A3.93,3.93,0,0,0,293.91,366.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.18,355.14a.9.9,0,0,1,.9-.9.89.89,0,1,1,0,1.78A.88.88,0,0,1,299.18,355.14Zm.35,3.67h1.1v11.47h-1.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.26,354h1.1v16.3h-1.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.27,363v7.27h-1v-2a4.39,4.39,0,0,1-4.13,2.13c-2.57,0-4.13-1.31-4.13-3.27,0-1.73,1.1-3.21,4.29-3.21h3.93V363c0-2.13-1.17-3.27-3.41-3.27a5.92,5.92,0,0,0-3.95,1.45l-.55-.79a7,7,0,0,1,4.59-1.63C317.69,358.72,319.27,360.17,319.27,363Zm-1.09,3.88v-2.15h-3.91c-2.37,0-3.21,1-3.21,2.31,0,1.49,1.16,2.41,3.19,2.41A3.93,3.93,0,0,0,318.18,366.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.22,364.54a5.56,5.56,0,0,1-5.67,5.82,5.12,5.12,0,0,1-4.7-2.79v2.71H323.8V354h1.1v7.45a5.12,5.12,0,0,1,4.65-2.71A5.55,5.55,0,0,1,335.22,364.54Zm-1.1,0a4.63,4.63,0,1,0-4.63,4.84A4.57,4.57,0,0,0,334.12,364.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.63,354h1.09v16.3h-1.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,364.81h-9.86a4.9,4.9,0,0,0,8.52,3l.64.73a5.48,5.48,0,0,1-4.33,1.86,5.62,5.62,0,0,1-5.9-5.82,5.49,5.49,0,1,1,11,0C354.07,364.59,354,364.7,354,364.81ZM344.2,364H353a4.4,4.4,0,0,0-8.79,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.39,297.85c0,17.37-12.75,32.5-40.77,32.5-13.59,0-27.88-3.78-37.41-10.51l9-17.37c7.42,5.6,17.65,8.82,27.88,8.82,11.34,0,18.35-4.76,18.35-12.74,0-7.71-5-12.75-22.84-12.75H129.5l5-55.2h59.82v18.21H153.45l-1.54,18.63h8C188.9,267.44,200.39,280.47,200.39,297.85Zm9.24-18.22c0-32.36,17.93-50.71,42-50.71s42,18.35,42,50.71-17.79,50.72-42,50.72S209.63,312,209.63,279.63Zm61.22,0c0-22.27-7.84-31.52-19.19-31.52s-19,9.25-19,31.52,7.84,31.52,19,31.52S270.85,301.91,270.85,279.63Zm104.94,19.06c0,16.53-12.75,31.66-40.63,31.66-13.73,0-27.88-3.78-37.41-10.51l8.83-17.37c7.43,5.6,17.79,8.82,28,8.82,11.35,0,18.35-4.62,18.35-12.6,0-7.43-5.46-12.05-18.35-12.05H324.23v-15l20.18-22.84H302.66V230.6h68.65v14.71l-22.14,25.21C366.82,273.33,375.79,284.25,375.79,298.69Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.24,82.79h0A3.48,3.48,0,0,1,326.33,78L332,74.41a3.48,3.48,0,0,1,4.81,1.09h0a3.48,3.48,0,0,1-1.09,4.81l-5.66,3.57A3.49,3.49,0,0,1,325.24,82.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.16,107.29a39.79,39.79,0,0,0-9.85-9.82,145.36,145.36,0,0,0-15.56-8.06l-3.23-18a61.53,61.53,0,0,0,8.28-9.8c2.92-4.71,2-7.87.13-11.13s-4.46-1.15-4.85.34a33.33,33.33,0,0,0-.52,4.75s-1.74-12-2.75-14.73-4.86-.1-4.52.81c0,0-1.16-3.41-3.55-3.45s-3.07,4-3.07,4-3.07-1.42-4.79.36-.9,6.24-.9,6.24-2.74,1-3.16,4.89-.08,10.7,1,12.57a20.08,20.08,0,0,1,1.45,2.78c-1.36,16.24-1.31,15.17-1.71,21.65-.28,4.56,2.71,15.16,7,19.57s19.64,12.2,19.64,12.2S317.23,118.33,322.16,107.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-138)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.26,122.48s16-4.15,20.9-15.19c0,0-.32-.47-.89-1.22l-4.16-3.47a139.3,139.3,0,0,0-17.57,2.61c-8.78,2-15.61-2.28-18.21-12s-5-24.11-5-24.11h0c-1.36,16.24-1.31,15.17-1.71,21.65-.28,4.56,2.71,15.16,7,19.57S301.26,122.48,301.26,122.48Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.26,122.48s16-4.15,20.9-15.19c0,0-.32-.47-.89-1.22l-4.16-3.47a139.3,139.3,0,0,0-17.57,2.61c-8.78,2-15.61-2.28-18.21-12s-5-24.11-5-24.11h0c-1.36,16.24-1.31,15.17-1.71,21.65-.28,4.56,2.71,15.16,7,19.57S301.26,122.48,301.26,122.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.16,107.29a39.79,39.79,0,0,0-9.85-9.82,145.36,145.36,0,0,0-15.56-8.06l-3.23-18a61.53,61.53,0,0,0,8.28-9.8c2.92-4.71,2-7.87.13-11.13s-4.46-1.15-4.85.34a33.33,33.33,0,0,0-.52,4.75s-1.74-12-2.75-14.73-4.86-.1-4.52.81c0,0-1.16-3.41-3.55-3.45s-3.07,4-3.07,4-3.07-1.42-4.79.36-.9,6.24-.9,6.24-2.74,1-3.16,4.89-.08,10.7,1,12.57a20.08,20.08,0,0,1,1.45,2.78c-1.36,16.24-1.31,15.17-1.71,21.65-.28,4.56,2.71,15.16,7,19.57s19.64,12.2,19.64,12.2S317.23,118.33,322.16,107.29Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.5,82.42l-2-11a61.53,61.53,0,0,0,8.28-9.8c2.92-4.71,2-7.87.13-11.13s-4.46-1.15-4.85.34a33.33,33.33,0,0,0-.52,4.75s-1.74-12-2.75-14.73-4.86-.1-4.52.81c0,0-1.16-3.41-3.55-3.45s-3.07,4-3.07,4-3.07-1.42-4.79.36-.9,6.24-.9,6.24-2.74,1-3.16,4.89-.08,10.7,1,12.57a20.08,20.08,0,0,1,1.45,2.78c-.6,7.18-.93,11-1.14,13.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.54,107.54a18.33,18.33,0,0,0,1.21,1.74c4.22-3.53,13.72-12,18-19.27-1.2-.38-2-.6-2-.6S287.91,101,279.54,107.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.56,55.55s-9.45-.35-10.45,7.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.29,
    y1: 41.63,
    x2: 289.61,
    y2: 51.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 282.67,
    y1: 42.22,
    x2: 283.32,
    y2: 51.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.98,
    y1: 48.82,
    x2: 278,
    y2: 54.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.51,51.21S280.84,53,276.73,56.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,114.24c3.48-3,3.21-9-.62-13.49-3.69-4.32-9.34-5.59-12.86-3,1.19,4.6,3.37,9.76,6.07,12.51A39.12,39.12,0,0,0,288,115,6,6,0,0,0,289,114.24Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,114.24c3.48-3,3.21-9-.62-13.49-3.69-4.32-9.34-5.59-12.86-3,1.19,4.6,3.37,9.76,6.07,12.51A39.12,39.12,0,0,0,288,115,6,6,0,0,0,289,114.24Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.21,125.93s-4.47.47-5.88,1.68S264.19,138,262.45,143.44s4.87,21.72,12.09,28,16.24,12.93,23.9,11.56,16.46-13.17,17.37-16.38-29.06-40-29.06-40S284.62,124.48,282.21,125.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-138)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.21,125.93s-.88.09-2,.3l1,1.69s-.92,9.48,5.58,20.22,17.89,17.56,17.56,21.46,1,9.11-8.78,8.46-20.16-17.24-23.74-25.37c-1.86-4.23-3.46-10.65-5.29-15.62a20.91,20.91,0,0,0-4.16,6.37c-1.74,5.44,4.87,21.72,12.09,28s16.24,12.93,23.9,11.56,16.46-13.17,17.37-16.38-29.06-40-29.06-40S284.62,124.48,282.21,125.93Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.21,125.93s-.88.09-2,.3l1,1.69s-.92,9.48,5.58,20.22,17.89,17.56,17.56,21.46,1,9.11-8.78,8.46-20.16-17.24-23.74-25.37c-1.86-4.23-3.46-10.65-5.29-15.62a20.91,20.91,0,0,0-4.16,6.37c-1.74,5.44,4.87,21.72,12.09,28s16.24,12.93,23.9,11.56,16.46-13.17,17.37-16.38-29.06-40-29.06-40S284.62,124.48,282.21,125.93Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282.21,125.93s-4.47.47-5.88,1.68S264.19,138,262.45,143.44s4.87,21.72,12.09,28,16.24,12.93,23.9,11.56,16.46-13.17,17.37-16.38-29.06-40-29.06-40S284.62,124.48,282.21,125.93Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.39,104.12s-4.74-1.6-11.8,1.4-24.72,13.37-27.31,22.4c-1.71,5.93,17,33.62,28.69,38.18,3.14,1.22,6,2.55,12.43-2.69s19.91-19.79,23.44-26.2-2-11.19-3.85-14S325.35,102,320.39,104.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-138)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.88,137.12,333.69,141s-12.68,15-17.23,18.87-18.87-5.53-23.75-10.09l-1.44-1.34c5.83,7.92,13.08,15.48,18.7,17.68,3.14,1.22,6,2.55,12.43-2.69s19.91-19.79,23.44-26.2A.36.36,0,0,0,345.88,137.12Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.55,135.78l6.56.85c2.91-6.12-2.29-10.7-4.12-13.44s-16.64-21.19-21.6-19.07a11.06,11.06,0,0,0-2.79-.41c-6,4.52-5.32,9.71.16,19.06S339.55,135.78,339.55,135.78Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.88,137.12,333.69,141s-12.68,15-17.23,18.87-18.87-5.53-23.75-10.09l-1.44-1.34c5.83,7.92,13.08,15.48,18.7,17.68,3.14,1.22,6,2.55,12.43-2.69s19.91-19.79,23.44-26.2A.36.36,0,0,0,345.88,137.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.55,135.78l6.56.85c2.91-6.12-2.29-10.7-4.12-13.44s-16.64-21.19-21.6-19.07a11.06,11.06,0,0,0-2.79-.41c-6,4.52-5.32,9.71.16,19.06S339.55,135.78,339.55,135.78Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M320.39,104.12s-4.74-1.6-11.8,1.4-24.72,13.37-27.31,22.4c-1.71,5.93,17,33.62,28.69,38.18,3.14,1.22,6,2.55,12.43-2.69s19.91-19.79,23.44-26.2-2-11.19-3.85-14S325.35,102,320.39,104.12Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.3,
    y: 117.55,
    width: 32.36,
    height: 27.62,
    rx: 5.89,
    transform: "translate(232.93 -195.3) rotate(53.91)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.52,230.22c-14.95-39-52.35-38.57-85.34-38.16-11.37.14-22.11.28-32-1-33.37-4.22-42.91-38.52-43-39a2.38,2.38,0,0,0-4.61,1.22c.1.38,10.39,37.84,47,42.48,10.23,1.3,21.64,1.15,32.68,1,33-.41,67.06-.84,80.83,35.09a49.43,49.43,0,0,1-8.95,49.48c-10.24,11.79-24.77,16.57-39.85,13.11-14.23-3.27-28.29-7.77-41.89-12.12-22.51-7.2-45.78-14.65-70.48-16.72-42.35-3.56-71.81,17.07-105.89,40.94-6.86,4.81-13.95,9.77-21.38,14.71l-4.23,2.82c-21.09,14.08-42.89,28.64-67.56,31.27-19.18,2-38.68-6.94-48.55-22.35A37.74,37.74,0,0,1,61,304.31,31.75,31.75,0,0,1,76.05,284c12.77-7.61,35.33-10.14,54.57-8l.33-4.75c-20.19-2.15-43.75.61-57.34,8.7a36.91,36.91,0,0,0-17.25,23.35,42.49,42.49,0,0,0,5.92,32.42c9.9,15.47,27.81,24.82,46.82,24.85a59.76,59.76,0,0,0,6.25-.33c25.83-2.75,49.14-18.31,69.69-32l4.22-2.82c7.49-5,14.6-10,21.48-14.77,33.33-23.35,62.11-43.52,102.76-40.1,24.16,2,47.17,9.39,69.42,16.51,13.7,4.38,27.86,8.91,42.28,12.22,16.86,3.87,33.08-1.46,44.52-14.62A54.23,54.23,0,0,0,479.52,230.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.4,121.06a3.25,3.25,0,1,1-3.25-3.25A3.25,3.25,0,0,1,313.4,121.06Z",
    style: {
      fill: "#2762E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.58,128.48a3.25,3.25,0,1,1-3.24-3.24A3.24,3.24,0,0,1,304.58,128.48Z",
    style: {
      fill: "#2762E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 341.93,
    cy: 103.81,
    r: 26.5,
    transform: "translate(-15.38 99.53) rotate(-16.2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-138)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.07,86.59a27,27,0,0,0-3-3A26.47,26.47,0,0,1,316.45,111a26.49,26.49,0,1,0,45.62-24.41Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.07,86.59a27,27,0,0,0-3-3A26.47,26.47,0,0,1,316.45,111a26.49,26.49,0,1,0,45.62-24.41Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 341.93,
    cy: 103.81,
    r: 26.5,
    transform: "translate(-15.38 99.53) rotate(-16.2)",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.46,
    y1: 122.13,
    x2: 373.18,
    y2: 115.53,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.23,116.36a2,2,0,0,0-2.65-3.1,2,2,0,1,0,2.65,3.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,130.13h0a3.48,3.48,0,0,1,.39-4.91l5.08-4.36a3.5,3.5,0,0,1,4.92.39h0a3.48,3.48,0,0,1-.38,4.91l-5.09,4.36A3.49,3.49,0,0,1,356,130.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.71,134.5s-10.29-2.78-14.34,4.95.52,27,.52,27-7.52,12.22-9.43,13.55-7.29.75-12.59,3.45-3.55,5.47-2.14,6.4,5.73-1.85,7-1.75,1.13,2.39-3.87,7.58S305.57,201,307,203.4a3.69,3.69,0,0,0,4,1.79,2.57,2.57,0,0,0,1.4,3.07c2.06,1,2.94.23,2.94.23s-.2,2.61,1.71,3.41a8.13,8.13,0,0,0,4.59,0s1.81,2.12,3.64,1.77,6-5.45,9.3-9.79,16-19.77,21-29.23,2.63-19,1.61-24.83S351.55,135.78,347.71,134.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-138)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.19,149.85c-1-5.83-5.64-14.07-9.48-15.35l-.24-.06a56.31,56.31,0,0,1,4.11,26.71c-1.3,16.58-16.51,29.66-21.14,34.47-3.71,3.86-8.38,9.27-15.11,13.27a3.25,3.25,0,0,0,1.71,3,8.13,8.13,0,0,0,4.59,0s1.81,2.12,3.64,1.77,6-5.45,9.3-9.79,16-19.77,21-29.23S358.21,155.68,357.19,149.85Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.19,149.85c-1-5.83-5.64-14.07-9.48-15.35l-.24-.06a56.31,56.31,0,0,1,4.11,26.71c-1.3,16.58-16.51,29.66-21.14,34.47-3.71,3.86-8.38,9.27-15.11,13.27a3.25,3.25,0,0,0,1.71,3,8.13,8.13,0,0,0,4.59,0s1.81,2.12,3.64,1.77,6-5.45,9.3-9.79,16-19.77,21-29.23S358.21,155.68,357.19,149.85Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.71,134.5s-10.29-2.78-14.34,4.95.52,27,.52,27-7.52,12.22-9.43,13.55-7.29.75-12.59,3.45-3.55,5.47-2.14,6.4,5.73-1.85,7-1.75,1.13,2.39-3.87,7.58S305.57,201,307,203.4a3.69,3.69,0,0,0,4,1.79,2.57,2.57,0,0,0,1.4,3.07c2.06,1,2.94.23,2.94.23s-.2,2.61,1.71,3.41a8.13,8.13,0,0,0,4.59,0s1.81,2.12,3.64,1.77,6-5.45,9.3-9.79,16-19.77,21-29.23,2.63-19,1.61-24.83S351.55,135.78,347.71,134.5Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.27,213.7c1.83-.35,6-5.45,9.3-9.79,1.87-2.45,6.75-8.46,11.54-14.93-3.21-11-12.71-14.29-16.94-15.2-1.91,2.86-3.87,5.6-4.71,6.19-1.91,1.33-7.29.75-12.59,3.45s-3.55,5.47-2.14,6.4,5.73-1.85,7-1.75,1.13,2.39-3.87,7.58S305.57,201,307,203.4a3.69,3.69,0,0,0,4,1.79,2.57,2.57,0,0,0,1.4,3.07c2.06,1,2.94.23,2.94.23s-.2,2.61,1.71,3.41a8.13,8.13,0,0,0,4.59,0S323.44,214.05,325.27,213.7Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,205.19a33.58,33.58,0,0,0,10-7.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.33,208.49a32.84,32.84,0,0,0,10.48-8.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.63,211.93s5.76-4.31,8.5-7.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.65,169.44c.21-.76.37-1.52.51-2.27-8.38-5.59-18.94-3.76-24.57-2.13.18.87.3,1.38.3,1.38l-.87,1.4C346.48,164.57,353.9,167,357.65,169.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.81,174.55a10.18,10.18,0,0,0,2.62,2.18c.41-.71.8-1.39,1.15-2a28.72,28.72,0,0,0,2.92-16.28,9.54,9.54,0,0,0-5.77,2.27A9.84,9.84,0,0,0,351.81,174.55Z",
    style: {
      fill: "#2762E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.06,138.09s4.16,12,9.51,12.89,12.79-8.19,14.3-15-3.8-12.29-11.48-19.13-18.69-10.82-28-5.63-23.07,20-23.07,20-8.61-7.57-13.18-3.66,1.39,15.87,5.6,20.8S222.63,160.52,230,158.8s13.21-15.55,18-19.62S256,136.86,257.06,138.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-7--inject-138)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269,141c-8.13-3.9-5.85-13.66-14-16.26s-7.48,2.93-14,13.34-18.54,9.75-26.67,7.15a79.89,79.89,0,0,1-7.59-2.89,34.21,34.21,0,0,0,4,6.11c4.21,4.93,11.86,12.09,19.22,10.37s13.21-15.55,18-19.62,8.06-2.32,9.11-1.09c0,0,4.16,12,9.51,12.89s12.79-8.19,14.3-15a10.36,10.36,0,0,0,.19-3.4l-.38-.08S277.1,144.89,269,141Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,141c-8.13-3.9-5.85-13.66-14-16.26s-7.48,2.93-14,13.34-18.54,9.75-26.67,7.15a79.89,79.89,0,0,1-7.59-2.89,34.21,34.21,0,0,0,4,6.11c4.21,4.93,11.86,12.09,19.22,10.37s13.21-15.55,18-19.62,8.06-2.32,9.11-1.09c0,0,4.16,12,9.51,12.89s12.79-8.19,14.3-15a10.36,10.36,0,0,0,.19-3.4l-.38-.08S277.1,144.89,269,141Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.06,138.09s4.16,12,9.51,12.89,12.79-8.19,14.3-15-3.8-12.29-11.48-19.13-18.69-10.82-28-5.63-23.07,20-23.07,20-8.61-7.57-13.18-3.66,1.39,15.87,5.6,20.8S222.63,160.52,230,158.8s13.21-15.55,18-19.62S256,136.86,257.06,138.09Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.83,119.18c-6.64,5.82-12.48,12.11-12.48,12.11s-8.61-7.57-13.18-3.66,1.39,15.87,5.6,20.8S222.63,160.52,230,158.8c6.64-1.55,12-13,16.52-18.15A88.79,88.79,0,0,1,230.83,119.18Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,109a22.56,22.56,0,0,0-2.46-.15,69.54,69.54,0,0,1,1.64,28,5.6,5.6,0,0,1,2.45-.1C255.18,129.66,255.59,117.91,253,109Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.61,124.58a8.79,8.79,0,1,1,1-12.4A8.79,8.79,0,0,1,258.61,124.58Z",
    style: {
      fill: "#2762E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,158.8a11,11,0,0,0,4.66-2.68c-4.71.78-13.41.52-21.32-9-7.7-9.24-7.83-16.43-7.07-20.21a4.87,4.87,0,0,0-1.09.69c-4.58,3.91,1.39,15.87,5.6,20.8S222.63,160.52,230,158.8Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.13,180.59s12.17,3.58,16-.24,4.4-15.43-3.88-20.35c-6-3.54-12.21-4-22.24-1.76s-19.66,8.93-20.83,19.49,2.9,30.42,2.9,30.42-11.15,2.61-10.63,8.61,13.73,8.09,20.18,7.52,16.74-2.63,19.61-9.62-5-19.78-5.54-26S279.52,180.73,281.13,180.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-8--inject-138)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.13,180.59s12.17,3.58,16-.24c2.5-2.49,3.59-8.26,1.78-13.35h0s1,5.21-6.18,6.51-18.86-1.3-24.06,5.2,2.27,19.84,2.92,28.62S270.27,219,261.49,220s-16.63-5.3-18.44-1.48c2.69,4.63,13.83,6.25,19.6,5.74,6.46-.57,16.74-2.63,19.61-9.62s-5-19.78-5.54-26S279.52,180.73,281.13,180.59Z",
    style: {
      fill: "#2762E6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.13,180.59s12.17,3.58,16-.24c2.5-2.49,3.59-8.26,1.78-13.35h0s1,5.21-6.18,6.51-18.86-1.3-24.06,5.2,2.27,19.84,2.92,28.62S270.27,219,261.49,220s-16.63-5.3-18.44-1.48c2.69,4.63,13.83,6.25,19.6,5.74,6.46-.57,16.74-2.63,19.61-9.62s-5-19.78-5.54-26S279.52,180.73,281.13,180.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.13,180.59s12.17,3.58,16-.24,4.4-15.43-3.88-20.35c-6-3.54-12.21-4-22.24-1.76s-19.66,8.93-20.83,19.49,2.9,30.42,2.9,30.42-11.15,2.61-10.63,8.61,13.73,8.09,20.18,7.52,16.74-2.63,19.61-9.62-5-19.78-5.54-26S279.52,180.73,281.13,180.59Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5,191c.88,8.79,2.6,17.19,2.6,17.19s-11.15,2.61-10.63,8.61,13.73,8.09,20.18,7.52,16.74-2.63,19.61-9.62c2.59-6.31-3.54-17.32-5.18-24A88.55,88.55,0,0,1,250.5,191Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.08,167.06a21.79,21.79,0,0,0-1.54,1.91,69.88,69.88,0,0,1,23.71,14.91,5.57,5.57,0,0,1,1.34-2C273.18,177.23,263.85,170.07,255.08,167.06Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.27,
    cy: 172.25,
    r: 8.8,
    transform: "translate(-39.6 86.65) rotate(-17.46)",
    style: {
      fill: "#2762E6",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.26,214.66a10.89,10.89,0,0,0,.52-5.35c-2.1,4.29-7.36,11.22-19.68,12.14-12,.9-17.93-3.17-20.55-6a4.58,4.58,0,0,0-.08,1.29c.53,6,13.73,8.09,20.18,7.52S279.39,221.65,282.26,214.66Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.87,92.66a93.78,93.78,0,0,1-7.17-10.92A22.59,22.59,0,1,0,363.21,106,91.3,91.3,0,0,1,350.87,92.66Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1914845705032349px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.06,113.17a7.26,7.26,0,1,1,.45-9.91A7,7,0,0,1,353.06,113.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.63,96.42a2.16,2.16,0,1,1,.23-3A2.15,2.15,0,0,1,345.63,96.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.16,
    y: 268.54,
    width: 6.45,
    height: 9.32,
    transform: "translate(27.38 -11.26) rotate(5.62)",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError503);
export default __webpack_public_path__ + "static/media/Error503.a6661771867d57e34e6bf92104240a50.svg";
export { ForwardRef as ReactComponent };